<div class="container is-mobile">
  @if (isNotBaseUrl) {
    <mat-toolbar class="toolbar" color="primary">
      <button
        [attr.aria-label]="'menu' | translate"
        (click)="snav.toggle()"
        matIconButton>
        <mat-icon svgIcon="Icons_BURGER" />
      </button>

      <div class="container-center">
        <h1 class="title-page">
          @if (showIcon) {
            <img src="./assets/icons/icon-full-white-text.svg" class="icon-youca" alt="YOUCA Logo">
          } @else {
            {{title | async}}
          }
        </h1>
      </div>

       @let child = selectedChildSignal();

         <button
           [style.visibility]="isNotPersonalization && isNotInstructionOnFirstRun() ? 'visible' : 'hidden'"
           [attr.aria-label]="'menu' | translate"
           (click)="onClickChild()"
           class="button-avatar">
           <div class="container-avatar-icon">
            @if (child?.avatar) {
              <img class="img-avatar" [src]="`../../../../assets/icons/${child.avatar}.svg`" alt="Avatar">
            }
           </div>
           @if (child === undefined) {
            <span>{{'create_child' | translate}}</span>
           } @else {
             <span>{{child.name}}</span>
           }
         </button>

    </mat-toolbar>
  }


  <mat-sidenav-container
    class="sidenav-container sidenav-container--mobile"
    [class.sidenav-container-background-blue]="isOnHotspotScreen || isOnStationListScreen">
    <mat-sidenav #snav
      mode="over"
      [fixedInViewport]="true"
      fixedTopGap="72"
      position="start"
      class="sidenav">
      <app-navigation-menu (closeSidenav)="snav.close()" />
    </mat-sidenav>

    <mat-sidenav-content class="content" [class.content--full]="isFullscreen">
      <ng-content />
    </mat-sidenav-content>
  </mat-sidenav-container>

  @if (isNotBaseUrl && isNotPersonalization && isNotInstructionOnFirstRun()) {
    <mat-toolbar
      class="bottom-nav"
      color="warn">
      @for (navElement of bottomNavElements; track navElement) {
        <button
          [attr.aria-label]="navElement.label"
          mat-flat-button
          [color]="url === navElement.route ? 'primary' : 'warn'"
          class="bottom-nav-btn"
          [class.bottom-nav-btn--selected]="url === navElement.route"
          (click)="navigateToRoute(navElement.route)"
          [disabled]="snav.opened || hideBackButtonOnSomeRoutes">
          <mat-icon [svgIcon]="navElement.icon" [class.icon-inverted]="url === navElement.route" />
          {{navElement.label | uppercase}}
        </button>
      }
    </mat-toolbar>
  }
</div>
